
import {
  TAKER_UPDATE_DATA_REQUEST, TAKER_UPDATE_DATA_SUCCESS, TAKER_UPDATE_DATA_ERROR,
  // TAKER_RETRIEVE_REQUEST, TAKER_RETRIEVE_SUCCESS, TAKER_RETRIEVE_ERROR,
  TAKER_CREATE_REQUEST, TAKER_CREATE_SUCCESS, TAKER_CREATE_ERROR,
  GLOBAL_QUOTATION_RESET_STATE_TAKER, GLOBAL_QUOTATION_SET_TAKER_DATA,
  TAKER_CREATE_OR_UPDATE_REQUEST, TAKER_CREATE_OR_UPDATE_SUCCESS, TAKER_CREATE_OR_UPDATE_ERROR,
} from 'Redux/types/globalQuotationTypes';

import { BACKEND_URL_CLIENT } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';


// Actualizar datos del cliente
const updateClientAction = (clientId, data) => ({
  [CALL_ACTIONS]: {
    TYPES: [TAKER_UPDATE_DATA_REQUEST, TAKER_UPDATE_DATA_SUCCESS, TAKER_UPDATE_DATA_ERROR],
    ENDPOINT: `${BACKEND_URL_CLIENT}${clientId}/`,
    METHOD: 'PUT',
    DATA: data,
  },
});

export const updateClient = (clientId, data) => (dispatch) => dispatch(updateClientAction(clientId, data));


// // ------------------------- ------------------------- ------------------------- ------------------------- -------------------------
// // Obtener o crear datos del cliente : data sera la cedula del cliente que se creara o se obtendra
// const fetchClient = (data) => ({
//   [CALL_ACTIONS]: {
//     TYPES: [TAKER_RETRIEVE_REQUEST, TAKER_RETRIEVE_SUCCESS, TAKER_RETRIEVE_ERROR],
//     // ENDPOINT: `${BACKEND_URL_CLIENT}${urlMethod}`,
//     ENDPOINT: BACKEND_URL_CLIENT,
//     METHOD: 'GET',
//     // DATA: data,
//     PARAMS: data,
//   },
// });

// export const getClient = (data) => (dispatch, getState) => {
//   const actualGlobalQuotation = getState().globalQuotation.globalQuotation;

//   const newData = {
//     quotation: '',
//     ...data,
//   };
//   if (actualGlobalQuotation) { newData.quotation = actualGlobalQuotation.id; }
//   return dispatch(fetchClient(newData));
// };


// ------------------------- ------------------------- ------------------------- ------------------------- -------------------------
// Obtener o crear datos del cliente : data sera la cedula del cliente que se creara o se obtendra
const createClientAction = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [TAKER_CREATE_REQUEST, TAKER_CREATE_SUCCESS, TAKER_CREATE_ERROR],
    ENDPOINT: BACKEND_URL_CLIENT,
    METHOD: 'POST',
    DATA: data,
  },
});
export const createClient = (data) => (dispatch) => dispatch(createClientAction(data));

// ------------------------------------ ------------------------------------ ------------------------------------
const resetGlobalQuotationTakerAction = (defaults) => ({
  type: GLOBAL_QUOTATION_RESET_STATE_TAKER,
  defaults,
});

export const resetGlobalQuotationTaker = (defaults = {}) => (dispatch) => dispatch(resetGlobalQuotationTakerAction(defaults));

// ------------------------------------ ------------------------------------ ------------------------------------
const setTakerDataGlobalQuotationAction = (newData) => ({
  type: GLOBAL_QUOTATION_SET_TAKER_DATA,
  newData,
});

export const setTakerDataGlobalQuotation = (new_data = {}) => (dispatch) => dispatch(setTakerDataGlobalQuotationAction(new_data));

// ------------------------------------ ------------------------------------ ------------------------------------
const createOrUpdateClientActionCreator = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [TAKER_CREATE_OR_UPDATE_REQUEST, TAKER_CREATE_OR_UPDATE_SUCCESS, TAKER_CREATE_OR_UPDATE_ERROR],
    ENDPOINT: `${BACKEND_URL_CLIENT}create_or_update/`,
    METHOD: 'POST',
    DATA: data,
  },
});
export const createOrUpdateClientAction = (data) => (dispatch) => dispatch(createOrUpdateClientActionCreator(data));
